__turbopack_context__.v({
  "body": "index-module-scss-module__qdbDJa__body",
  "hideSvg": "index-module-scss-module__qdbDJa__hideSvg",
  "select": "index-module-scss-module__qdbDJa__select",
  "selectItem": "index-module-scss-module__qdbDJa__selectItem",
  "selectItem__active": "index-module-scss-module__qdbDJa__selectItem__active",
  "select__active": "index-module-scss-module__qdbDJa__select__active",
  "title": "index-module-scss-module__qdbDJa__title",
});
